import React, {useCallback, useEffect, useState} from "react";
import Loading from "components/Loading";
import {
    EllipsisTextColumn,
    FlexGrow,
    ListContentWrap,
    PageArticleWrap,
    PageHeaderTitleButtonStyle,
} from "components/layout/Layout";
import {
    BusInfo,
    BusQueryParams,
    BusRequestType,
    DeviceInfo,
    ListResult,
    SingleResult,
} from "../../type/type";
import {NoDataWithImageText} from "components/NoDataComponent";
import {OutlinePrimaryBtn, SolidPrimaryBtn, SolidPrimarySubBtn, SolidRedBtn} from "components/button/Button";
import styled from "styled-components";
import {
    createBusInfo,
    getBuses,
    getDeviceListHandler,
    removeBusInfo,
    updateBusInfo,
} from "../../api/api";
import {formattedSelectOptionNotAll } from "../../utils/commonUtils";
import {DefaultModalComponent, ModalPropsInterface, ModalTitle, ModalType} from "components/ModalComponent";
import {selectOption, SelectOption} from "components/input/Input";

const ArticleWrap = styled.div`
    width: 100%;
    height: calc(100% - 3.75rem);
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const FilterContainer = styled.nav`
  background-color: ${({theme}) => theme.rootWhite};
  padding: 1rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 2rem;
`;

const FilterWrap = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  min-width: 12.5rem;
  > div {
    width: 100%;
  }
  > label{
      min-width:3rem;
  }
`;

const TableColumn = styled.div`
  min-height: 3.75rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.newTheme.border.primaryBd};
  > div {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
  }
  &:hover {
    background-color: ${({ theme }) => theme.newTheme.table.tableBodyHoverBg};
  }
    .bus_status span {
        display: flex;
        align-items: center;
        border-radius: 50%;
        aspect-ratio: 1 / 1;
        height: 3rem;
    }
`;

const InputWrap = styled.div`
    width: 100%;
    display: flex;

    .required_value::after {
        position: absolute;
        content: "*";
        color: ${({theme}) => theme.newTheme.default.error};
    }
    
    input[type='checkbox'].toggle-checkbox {
        appearance: none;
        position: relative;
        width: 4rem;
        height: 2rem;
        background-color: #C4C4C4;
        border-radius: 1rem;

        &::before {
            content: '';
            position: absolute;
            left: 0.25rem;
            width: 2rem;
            height: 2rem;
            border-radius: 50%;
            transform: scale(0.8);
            background-color: ${({ theme }) => theme.rootWhite};
            transition: .4s;
        }

        &:checked {
            background-color: ${({ theme }) => theme.newTheme.default.primary};
            &::before {
                left: calc(100% - 2rem - 0.25rem);
            }
        }
    }
`;
const InputWrapC = styled(InputWrap)`
  flex-direction: column;
  gap: 0.5rem;
  padding-bottom: 1rem;
`;

const InputWrapR = styled(InputWrap)`
  flex-direction: row;
  gap: 1rem;
  align-items: center;

  button {
    width: 100%;
    line-height: 1;
  }
`;

const NoDataWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`

const NODATATEXT = [
    { index: 1, text: "아직 등록된 차량이 없어요." },
    { index: 2, text: "새로운 차량을 등록해 주세요!" },
];

interface BusListViewerProps {
    busList:BusInfo[];
    deviceList:selectOption[];
    openModal:(modalType:ModalType) => void;
    changeRequestBusHandler:(id:number,busInfo:BusInfo) => void;
}

//차량 목록 테이블 리스트
const BusListTableViewer: React.FC<BusListViewerProps> = ({ busList, deviceList, openModal, changeRequestBusHandler }) => {

    return (

        <div className="list-one-wrap" style={{paddingTop:'1rem'}}>
            <div className="list-table">
                <nav className="list-table-header">
                    <div className="w-5">No.</div>
                    <FlexGrow className="w-10">차량 명</FlexGrow>
                    <FlexGrow className="w-20">차량 번호</FlexGrow>
                    <FlexGrow className="w-20">연결 단말기</FlexGrow>
                    <FlexGrow className="w-15">MDVR IP</FlexGrow>
                    <FlexGrow className="w-20">MDVR P2P</FlexGrow>
                    <div className="w-10"></div>
                </nav>
            {busList.map((busInfo:BusInfo, index) => {
                return (
                    <TableColumn key={busInfo.id}>
                        <div className="w-5">{ index + 1}</div>
                        <FlexGrow className="w-10">
                            <EllipsisTextColumn>{busInfo.name}</EllipsisTextColumn>
                        </FlexGrow>
                        <FlexGrow className="w-20">
                            <EllipsisTextColumn>{busInfo.plate_number}</EllipsisTextColumn>
                        </FlexGrow>
                        <FlexGrow className="w-20">
                            <EllipsisTextColumn>연결 단말기</EllipsisTextColumn>
                        </FlexGrow>
                        <FlexGrow className="w-15">
                            <EllipsisTextColumn>MDVR IP</EllipsisTextColumn>
                        </FlexGrow>
                        <FlexGrow className="w-20">
                            <EllipsisTextColumn>MDVR P2P</EllipsisTextColumn>
                        </FlexGrow>
                        <div className="w-10">
                            <OutlinePrimaryBtn type="button"
                                className="default-btn"
                                onClick={() => { openModal('updateBus'); changeRequestBusHandler(busInfo.id, busInfo); }}>
                                수정하기
                            </OutlinePrimaryBtn>
                        </div>
                    </TableColumn>
                )
            })}
            </div>
        </div>
    );
};


export const Bus = () => {
    const [loading, setLoading] = useState<boolean>(false);

    //차량 목록
    const [busList, setBusList] = useState<BusInfo[]>([]);
    const [totalCount, setTotalCount] = useState(0);

    //수정하기 클릭 시 해당 차량의 id
    const [busClickId, setBusClickId] = useState<number>(0);
    
    //단말기 select - option
    const [selectOptionDevice, setSelectOptionDevice] = useState<selectOption[]>([]);

    //사용자 API 파라미터
    const [busQueryParams, setBusQueryParams] = useState<BusQueryParams>({
        page: 1,
        size: 1000,
        name: "",
        plate_number: ""
    });

    //버스 등록/수정 시 입력한 정보 초기값
    const [requestBus, setRequestBus] = useState<BusRequestType>({
        plate_number: "",
        vin_number: "",
        name: "",
        device_id: 0,
        mdvr_ip: "",
        mdvr_port: 0,
        mdvr_id: "",
        mdvr_pw: "",
        mdvr_p2p_uuid: "",
    });

    //모달 상태
    const [modalProps, setModalProps] = useState<ModalPropsInterface>({
        isOpen: false,
        isClose: () => {},
        title: "",
        content: null,
        button: null,
        type: ""
    });

    //반 등록/수정 모달 열기 버튼 클릭 시
    const openModal = (modalType:ModalType) => {
        let title: ModalTitle = "";
        let content:JSX.Element = <></>;
        let button:JSX.Element = <></>;
        switch (modalType) {
            case "createBus":
                title = "신규 차량 등록";
                break;
            case "updateBus":
                title = "차량 정보 수정";
                break;
        }

        setModalProps({
            isOpen: true,
            isClose: () => setModalProps({...modalProps, isOpen: false}),
            title: title,
            content: content,
            button: button,
            type: modalType
        });
    }

    //신규 차량 등록 버튼 클릭 시 값 초기화
    function initRequestClass(){
        setRequestBus({
            plate_number: "",
            vin_number: "",
            name: "",
            device_id: 0,
            mdvr_ip: "",
            mdvr_port: 0,
            mdvr_id: "",
            mdvr_pw: "",
            mdvr_p2p_uuid: "",
        });
    }

    //수정하기 클릭 시 requestBus에 해당 차량 정보 저장
    function changeRequestBusHandler(busId: number, busInfo: BusInfo) {
        setBusClickId(busId);
        //클릭한 차량 정보 저장
        setRequestBus({
            plate_number: busInfo.plate_number,
            vin_number: busInfo.vin_number,
            name: busInfo.name,
            device_id: busInfo.device_id,
            mdvr_ip: busInfo.mdvr_ip,
            mdvr_port: busInfo.mdvr_port,
            mdvr_id: busInfo.mdvr_id,
            mdvr_pw: busInfo.mdvr_pw,
            mdvr_p2p_uuid: busInfo.mdvr_p2p_uuid,
        });
    }

    //mdvr p2p 사용 여부
    const [isUseP2p, setIsUseP2p] = useState(false);

    // 등록/수정 완료 버튼 클릭 시
    async function validateBusForm(){
        if(requestBus.name === "") {
            alert("차량 명을 입력해주세요.");
            return;
        }
        if(requestBus.plate_number === "") {
            alert("차량 번호를 입력해주세요.");
            return;
        }

        modalProps.type === "createBus" ? await createBus() : await updateBus();
        async function createBus(){
            try {
                const res:SingleResult<any> = await createBusInfo(requestBus);
                if (res.code === 200) {
                    alert("차량 등록이 완료되었습니다.");
                    setModalProps({ ...modalProps, isOpen: false });
                    getBusList();
                }
            } catch (e) {
                console.error(e);
            }
        }

        async function updateBus(){
            try{

                const res:SingleResult<any> = await updateBusInfo(busClickId, requestBus);
                if (res.code === 200) {
                    alert("차량 수정이 완료되었습니다.");
                    setModalProps({ ...modalProps, isOpen: false });
                    getBusList();
                }

            }
            catch (e) {
                console.error(e);
            }
        }
    }

    // 삭제버튼 클릭 시
    async function deleteBusForm(){
        const res = window.confirm('해당 차량을 삭제하시겠습니다?');

        if (!res) return;
        
        try {
            const deleteRes:SingleResult<any> = await removeBusInfo(busClickId);
            if (deleteRes.code === 200) {
                alert("차량이 삭제되었습니다.");
                setModalProps({ ...modalProps, isOpen: false });
                getBusList();
            }
            
        } catch (error) {
            console.error("delete API error ",error);
        }

    }

    //차량 등록/수정 모달 컨텐츠
    const busModalContent = (): JSX.Element => {

        function updateRequestBus(updates: Partial<BusRequestType>) {
            setRequestBus((prevRequestBus) => ({
                ...prevRequestBus,
                ...updates,
            }));
        }

        const handleInputChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
            const { name, value } = e.target;
            // 상태 업데이트
            if (isUseP2p) {
                updateRequestBus({ 'mdvr_ip': '', 'mdvr_port': 0, [name]: value });
            }
            else {
                updateRequestBus({ 'mdvr_p2p_uuid': '', [name]: value });
            }
        };

        const handleChangeOption = (deviceId: number) => {
            updateRequestBus({ device_id: deviceId }); // device 선택 시 상태 업데이트
        };

        return (
            <>
                <InputWrap>
                    <InputWrapC>
                        <label className="required_value">차량명</label>
                        <input type="text" name="name" onChange={handleInputChange} value={requestBus.name} placeholder="차량 명 입력"/>
                    </InputWrapC>
                </InputWrap>
                <InputWrap>
                    <InputWrapC>
                        <label className="required_value">차량 번호</label>
                        <input type="text" name="plate_number" onChange={handleInputChange} value={requestBus.plate_number} placeholder="차량 번호 입력"/>
                    </InputWrapC>
                </InputWrap>
                <InputWrap>
                    <InputWrapC>
                        <label>전차 출결 단말기</label>
                        <SelectOption optionData={selectOptionDevice}
                                      defaultValue={requestBus.device_id}
                                      onChange={(deviceId: number) => handleChangeOption(deviceId)}/>
                    </InputWrapC>
                </InputWrap>

                <InputWrapC>
                    <InputWrapR style={{justifyContent: 'space-between'}}>
                        <label>MDVR P2P 사용</label>
                        <input type="checkbox" className="toggle-checkbox" checked={isUseP2p} onChange={() => setIsUseP2p(prev => !prev)} />
                    </InputWrapR>
                </InputWrapC>

                {
                    !isUseP2p ?
                        <>
                            <InputWrap>
                                <InputWrapC>
                                    <label>MDVR IP 주소</label>
                                    <input type="text" value={requestBus.mdvr_ip} onChange={handleInputChange} name="mdvr_ip" placeholder="ip 입력"/>
                                </InputWrapC>
                            </InputWrap>
                            <InputWrap>
                                <InputWrapC>
                                    <label>MDVR IP 포트</label>
                                    <input type="text" value={requestBus.mdvr_port} onChange={handleInputChange} name="mdvr_port" placeholder="port 입력"/>
                                </InputWrapC>
                            </InputWrap>
                        </>
                        :
                        <InputWrap>
                            <InputWrapC>
                                <label>MDVR P2P UUID</label>
                                <input type="text" value={requestBus.mdvr_p2p_uuid} onChange={handleInputChange} name="mdvr_p2p_uuid" placeholder="uuid 입력"/>
                            </InputWrapC>
                        </InputWrap>
                }

                <InputWrap>
                    <InputWrapC>
                        <label>MDVR 접속 ID</label>
                        <input type="text" value={requestBus.mdvr_id} onChange={handleInputChange} name="mdvr_id" placeholder="접속 ID 입력"/>
                    </InputWrapC>
                </InputWrap>

                <InputWrap>
                    <InputWrapC>
                        <label>MDVR 접속 비밀번호</label>
                        <input type="password" value={requestBus.mdvr_pw} onChange={handleInputChange} name="mdvr_pw" placeholder="접속 비밀번호 입력"/>
                    </InputWrapC>
                </InputWrap>
            </>
        )
    }
    const busModalButton = (): JSX.Element => {

        return (
            <>
                {
                    modalProps.type === "createBus" ?
                        (<SolidPrimaryBtn onClick={validateBusForm} className="default-btn" style={{width:"100%"}}>
                            등록 완료
                        </SolidPrimaryBtn>)
                        :
                        (<InputWrapR>
                            <SolidPrimaryBtn onClick={validateBusForm}>수정 완료</SolidPrimaryBtn>
                            <SolidRedBtn onClick={deleteBusForm}>삭제</SolidRedBtn>
                        </InputWrapR>)
                }
            </>
        )
    }

    //사용자 검색 조건 변경
    function changeUserQueryParams(updates: Partial<BusQueryParams>) {
        setBusQueryParams({
            ...busQueryParams,
            ...updates,
        });
    }
    
    //차량 검색 변경
    function handleBusSearch(e: React.ChangeEvent<HTMLInputElement>) {
        const { name, value } = e.target;
        if (!value) {
            changeUserQueryParams({[name] : ""})
            return;
        }
        changeUserQueryParams({ [name]: value });
    }


    const getDeviceList = useCallback(async () => {
        try {

            const deviceRes: ListResult<DeviceInfo> = await getDeviceListHandler();
            if (deviceRes.code === 200) {
                const deviceOption = formattedSelectOptionNotAll(deviceRes.data.map((device: DeviceInfo) => ({ label: device.name, value: device.id })))
                setSelectOptionDevice(deviceOption);
            }
            
        } catch (e) {
            console.error(e);
        }
    }, []);

    const getBusList = useCallback(async () => {
        try {
            setLoading(true);
            setBusList([]);

            const busRes: ListResult<BusInfo> = await getBuses(busQueryParams);
            if (busRes.code === 200) {
                setBusList(busRes.data);
                setTotalCount(busRes.total_count);
            }
            
        } catch (e) {
            console.error(e);
        }
        finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        getBusList();
        getDeviceList();
    }, [getBusList, getDeviceList]);

    return (
        loading ? <Loading /> : (
            <>
                <PageHeaderTitleButtonStyle>
                    <p className="header-title">차량 관리</p>
                    <div className="button-wrap">
                        <SolidPrimaryBtn className="default-btn" onClick={() => {openModal('createBus');initRequestClass();}}>
                            신규 등록
                        </SolidPrimaryBtn>
                    </div>
                </PageHeaderTitleButtonStyle>
                <ArticleWrap>
                    <FilterContainer>
                        <FilterWrap>
                            <label>차량 명</label>
                            <input type="text"
                                name="name"
                                placeholder="차량 명을 입력하세요."
                                onChange={(e) => {handleBusSearch(e)}}
                                onKeyDown={(e) => e.key === 'Enter' && getBusList()}/>
                        </FilterWrap>

                        <FilterWrap>
                            <label>차량 번호</label>
                            <input type="text"
                                name="plate_number"
                                placeholder="차량 번호를 입력하세요."
                                onChange={(e) => {handleBusSearch(e)}}
                                onKeyDown={(e) => e.key === 'Enter' && getBusList()}/>
                        </FilterWrap>

                        <SolidPrimarySubBtn className="default-btn" onClick={getBusList}>조회</SolidPrimarySubBtn>
                    </FilterContainer>

                    <PageArticleWrap>
                        <article className="list-content-container">
                            <div className="article-header">
                                <p>
                                    <span className="article-header-title">차량 목록({totalCount})</span>
                                </p>
                            </div>
                            <ListContentWrap>
                                {busList.length === 0 ? (
                                    <NoDataWrap>
                                        <NoDataWithImageText text={NODATATEXT}/>
                                    </NoDataWrap>
                                ) : (
                                    <BusListTableViewer busList={busList} deviceList={selectOptionDevice} openModal={openModal} changeRequestBusHandler={changeRequestBusHandler}/>
                                )}
                            </ListContentWrap>
                        </article>
                    </PageArticleWrap>
                </ArticleWrap>
                {/*content에 렌더링할 컴포넌트를 전달하여 최신 상태로 리렌더링*/}
                <DefaultModalComponent
                    isOpen={modalProps.isOpen}
                    content={busModalContent()}
                    button={busModalButton()}
                    type={modalProps.type}
                    isClose={modalProps.isClose}
                    title={modalProps.title} />
            </>
        )
    )
}
